// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const DrawerContents = styled.div`
  padding: 60px 20px 60px 20px;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';
